import { BoosterOption, getOptionForPath } from './boosterOptions';

/** Visits to record on a location change: the option left, then the option entered. */
export const getVisitsForNavigation = (previousPath: string | null, nextPath: string): BoosterOption[] => {
  const previous = previousPath === null ? null : getOptionForPath(previousPath);
  const next = getOptionForPath(nextPath);
  if (previous === next) {
    return previousPath === null && next !== null ? [next] : [];
  }
  return [previous, next].filter((option): option is BoosterOption => option !== null);
};

export const getVisitForTick = (path: string): BoosterOption | null => getOptionForPath(path);
